/**
 * Shared utility functions for package pages
 */

import { formatCurrencyFromCents } from './currency'

/**
 * Calculate total session count from package items
 * @param {Array} items - Array of package items with num_units
 * @returns {number} Total session count
 */
export const getTotalSessionCount = (items) => {
  if (!items || !Array.isArray(items)) return 0

  return items.reduce((total, item) => total + (item.num_units || 0), 0)
}

/**
 * Get formatted package price from package or purchased package data
 * @param {Object} data - Package data with variants or purchased package data
 * @returns {string} Formatted price string
 */
export const getPackagePrice = (data) => {
  // Handle purchased package format (direct amount_cents)
  if (data?.amount_cents) {
    const currencyCode = data.currency || 'USD'
    return `${formatCurrencyFromCents(data.amount_cents, currencyCode)} ${currencyCode}`
  }

  // Handle package format (nested in variants)
  if (data?.variants?.[0]?.price) {
    const { amount_cents: amountCents, currency } = data.variants[0].price
    const currencyCode = currency || ''
    return `${formatCurrencyFromCents(amountCents, currencyCode)} ${currencyCode}`
  }

  return '$0'
}

export const isPackagePaymentLink = (data) => data?.package_type === 'PAYMENT_LINK'
